import { auth } from "./guards";
// 投保、计划书、支付 打包成一个模块

export default Route => {
  // 计划书
  Route.group({ prefix: "/plan", beforeEnter: auth }, () => {
    Route.view("/:code(\\d+)", () =>
      import(/* webpackChunkName: "insure" */ "../views/plan/index.vue")
    ).options({
      name: "plan",
      props: true
    });
  });
  //美亚计划书
  Route.group({ prefix: "/aigPlan", beforeEnter: auth }, () => {
    Route.view("/:code(\\d+)", () =>
      import(/* webpackChunkName: "insure" */ "../views/aigPlan/index.vue")
    ).options({
      name: "plan",
      props: true
    });
  });
  //美亚计划书B版
  Route.group({ prefix: "/aigPlanB", beforeEnter: auth }, () => {
    Route.view("/:code(\\d+)", () =>
        import(/* webpackChunkName: "insure" */ "../views/aigPlan/indexB.vue")
    ).options({
      name: "plan",
      props: true
    });
  });
  // 投保
  Route.group({ prefix: "/insure"}, () => {
    Route.view("/1001", () =>
      import(/* webpackChunkName: "insure" */ "../views/insure/index.vue")
    ).options({
      name: "insure",
      props: true
    });
  });
   // 投保
   Route.group({ prefix: "/insure"}, () => {
    Route.view("/2016", () =>
      import(/* webpackChunkName: "insure" */ "../views/insure/aig.vue")
    ).options({
      name: "insure",
      props: true
    });
  });
   // 投保线下支付
   Route.group({ prefix: "/insure"}, () => {
    Route.view("/downPay", () =>
      import(/* webpackChunkName: "insure" */ "../views/insure/downpay.vue")
    ).options({
      name: "insure",
      props: true
    });
  });
  // 泰康投保
  Route.group({ prefix: "/insure"}, () => {
    Route.view("/1074", () =>
      import(/* webpackChunkName: "insure" */ "../views/insure/tk.vue")
    ).options({
      name: "insure",
      props: true
    });
  });
   // 珠峰投保
   Route.group({ prefix: "/insure"}, () => {
    Route.view("/1075", () =>
      import(/* webpackChunkName: "insure" */ "../views/insure/zf.vue")
    ).options({
      name: "insure",
      props: true
    });
  });
  // 支付
  Route.group({ prefix: "/pay", beforeEnter: auth }, () => {
    Route.view("/1001", () =>
      import(/* webpackChunkName: "insure" */ "../views/pay/index.vue")
    ).options({
      name: "pay",
      props: true
    });
    Route.view("/1074", () =>
      import(/* webpackChunkName: "insure" */ "../views/pay/tkPay.vue")
    ).options({
      name: "tkpay",
      props: true
    });
  });
  // 投保
  Route.group({ prefix: "/insure"}, () => {
    Route.view("/2017", () =>
        import(/* webpackChunkName: "insure" */ "../views/insure/aig2017.vue")
    ).options({
      name: "insure",
      props: true
    });
  });
};
